import type { MetricApiFilter, MetricFilter } from './types';

// convertFilters convert the API representation of a Filter into a typed Filter object to be used on
// the frontend. The API version has an untyped array for the values field.
export function convertFilters(apiFilter: MetricApiFilter): MetricFilter {
  const { type, values, ...rest } = apiFilter;

  if (type === 'group') {
    // group filters always contain an array of Filter values.
    const typecastedValues = values.map((val: unknown): MetricFilter => {
      const filterVal: MetricApiFilter = val as MetricApiFilter;
      return convertFilters(filterVal);
    });
    const op = rest.op === 'or' ? 'or' : 'and';
    return {
      ...rest,
      negate: false,
      op,
      type,
      values: typecastedValues,
    };
  }

  return {
    ...rest,
    type,
    values: values as string[],
  };
}
